<template>
    <div class="transcript">
        <div class="transcript__btns" data-flex="row">
            <button 
                class="link" 
                :aria-expanded="opened.toString()" 
                aria-controls="transcript" 
                @click.prevent="opened = !opened"
            >
                <span v-show="false" />
                <span v-html="opened ? 'Close transcript' : 'View Transcript'"  />
            </button>
            <a 
                class="link"
                rel="noopener"
                href="/award-video-transcript-26.docx" 
                download="award-video-transcript.docx"
            >
                <span v-show="false" />
                <span v-html="'Download transcript'"  />
            </a>
        </div>
        <div class="transcript__wrapper">
            <transition name="fade">
                <div class="transcript__text" id="transcript" v-show="opened">
                    <slot />
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        opened: false,
    })
}
</script>